import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { subscribeToKekaStatus } from '../../../services/keka';
import styles from './KekaTile.module.scss';

export const KekaTile = () => {
  const companyId = useSelector(
    (s) => s.auth.profile?.activeCompany?.companyId
  );
  const history = useHistory();

  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const unsub = subscribeToKekaStatus(companyId, (status) =>
      setConnected(status.connected)
    );
    return unsub;
  }, [companyId]);

  return (
    <div
      className={styles.tile}
      onClick={() => history.push(appRoutes().integrationsKeka)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === 'Enter' && history.push(appRoutes().integrationsKeka)
      }
    >
      <div className={styles.logo}>K</div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <span className={styles.name}>Keka HR</span>
          <span
            className={`${styles.badge} ${connected ? styles.connected : styles.disconnected}`}
          >
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        <p className={styles.description}>
          Push Prodaff tracked hours to Keka as attendance records.
        </p>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};
